import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const getSellerAnalytics = () =>
  api.get(ENDPOINTS.SELLER_ANALYTICS.ANALYTICS);